import React from "react";
import './App.scss';
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import { Provider } from "react-redux";
import ToastComponent from "./components/Common/ToastComponent";
import ThemeProvider from "./Context/ThemeProvider";
import AppLayout from "./AppLayout";

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <div className="App">
          <PersistGate persistor={persistor}>
            <BrowserRouter>
              <AppLayout />
            </BrowserRouter>
            <ToastComponent />
          </PersistGate>
        </div>
      </ThemeProvider>
    </Provider>
  );
}


export default App;
